import React from 'react';

import { Modal, Row, Col,  Button} from 'antd';
import axios from '../util/Api'

import picto_home             from './assets/home/picto_home.png';
import picto_analyse_bleu from './assets/analyseResume/picto_analyse_bleu.svg';
import goutte_orange      from './assets/analyseResume/goutte_orange.png';
import goutte_verte       from './assets/analyseResume/goutte_verte.png';
import goutte_rouge       from './assets/analyseResume/goutte_rouge.png';
import { withTranslation } from 'react-i18next';

import './css/navBar.css';

import {verifIsLogged, getMachineId, getBaseURL, getPays, setLanguage, getLanguage, getColorWithState, setDisconnectMachineId} from "../util/Toolbox";




import './css/analyseResume.css';

import {
  CaretUpOutlined,
  DownloadOutlined,
  ShareAltOutlined,
  LoadingOutlined
} from '@ant-design/icons';



 class AnalyseResume extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      VolumeBassin : '',
      TypeFiltration : '',
      TypeDesinfection : '',
      TypeDesinfection_CONST : '',
      TypeFiltration_CONST : '',
      TemperatureEau : '',
      IsTempsFiltrationClicked : true,
      IsStabilisantClicked : true,
      IsEauClairTransparentClicked : true,
      TempsFiltrationText : '',
      StabilisantText : '',
      EauClairTransparente : '',
      ShowTempsFiltration : true,
      typeAnalyse_LIST : [],
      IsStopAnalyse: false,
      LibelleEtapeInfoStop : '',
      baseURL : '',
      loadingDownload : false,
      loadingShare : false,
      language : getLanguage(),
      languages_LIST : [],
    }

  }


  async componentDidMount() {

    const search  = window.location.search;
    const params  = new URLSearchParams(search);
    const analyse  = params.get('analyse');

    verifIsLogged();

    let baseURL = getBaseURL();
    this.setState({baseURL});

    let languages_LIST = getPays();
    this.setState({languages_LIST : languages_LIST});

    const {i18n } = this.props;
        let newLang = getLanguage();
        i18n.changeLanguage(newLang);
        setLanguage(newLang);
        this.setState({language : newLang});

    // Appel API
    this.loadAnalyse(analyse);

  }


  getTempsFiltrationTitreLanguage(tempsFiltrationResult){

    if(this.state.language == 'fr'){
      return tempsFiltrationResult.tempsFiltrationTitre
    }

    if(this.state.language == 'en'){
      return tempsFiltrationResult.tempsFiltrationTitreAnglais
    }

    if(this.state.language == 'de'){
      return tempsFiltrationResult.tempsFiltrationTitreAllemand
    }

    if(this.state.language == 'es'){
      return tempsFiltrationResult.tempsFiltrationTitreEspagnol
    }

    if(this.state.language == 'it'){
      return tempsFiltrationResult.tempsFiltrationTitreItalien
    }

    if(this.state.language == 'pt-PT'){
      return tempsFiltrationResult.tempsFiltrationTitrePortugais
    }

    return tempsFiltrationResult.tempsFiltrationTitre
  }

  getTempsFiltrationDescriptionLanguage(tempsFiltrationResult){

    if(this.state.language == 'fr'){
      return tempsFiltrationResult.tempsFiltrationDescription
    }

    if(this.state.language == 'en'){
      return tempsFiltrationResult.tempsFiltrationDescriptionAnglais
    }

    if(this.state.language == 'de'){
      return tempsFiltrationResult.tempsFiltrationDescriptionAllemand
    }

    if(this.state.language == 'es'){
      return tempsFiltrationResult.tempsFiltrationDescriptionEspagnol
    }

    if(this.state.language == 'it'){
      return tempsFiltrationResult.tempsFiltrationDescriptionItalien
    }

     if(this.state.language == 'pt-PT'){
      return tempsFiltrationResult.tempsFiltrationDescriptionPortugais
    }

    return tempsFiltrationResult.tempsFiltrationDescription
  }


  getTempsFiltrationTypeLanguage(tempsFiltrationResult){

    if(this.state.language == 'fr'){
      return tempsFiltrationResult.LibelleTypeAnalyse
    }

    if(this.state.language == 'en'){
      return tempsFiltrationResult.LibelleTypeAnalyseAnglais
    }

    if(this.state.language == 'de'){
      return tempsFiltrationResult.LibelleTypeAnalyseAllemand
    }

    if(this.state.language == 'es'){
      return tempsFiltrationResult.LibelleTypeAnalyseEspagnol
    }

    if(this.state.language == 'it'){
      return tempsFiltrationResult.LibelleTypeAnalyseItalien
    }
     if(this.state.language == 'pt-PT'){
      return tempsFiltrationResult.LibelleTypeAnalysePortugais
    }

    return tempsFiltrationResult.LibelleTypeAnalyse
  }



  getTempsFiltrationEtapeInfo(item){

    if(this.state.language == 'fr'){
      return item.LibelleEtapeInfo
    }

    if(this.state.language == 'en'){
      return item.LibelleEtapeInfoAnglais
    }

    if(this.state.language == 'de'){
      return item.LibelleEtapeInfoAllemand
    }

    if(this.state.language == 'es'){
      return item.LibelleEtapeInfoEspagnol
    }

    if(this.state.language == 'it'){
      return item.LibelleEtapeInfoItalien
    }
     if(this.state.language == 'pt-PT'){
      return item.LibelleEtapeInfoPortugais
    }

    return item.LibelleEtapeInfo
  }




  
  




   // Fonction pour changer la langue
    handleChangeLanguage = (event) => {
        const newLang = event.target.value;
        // Définir la langue  
        const {i18n } = this.props;
        console.log(newLang);
        i18n.changeLanguage(newLang);
        setLanguage(newLang);
        this.setState({language : newLang});
    };


  loadAnalyse(analyse){

    axios.get(`analyse/${analyse}/analyseItem`,
    ).then(({data}) => {

      if(data.success == 'success'){
          console.log(data.result);

          this.setState({typeAnalyse_LIST : data.result.typeAnalyse_LIST, GUID_Analyse : analyse,  IsStopFacultatif: data.result.IsStopFacultatif, LibelleEtapeInfoFacult : data.result.LibelleEtapeInfoFacult,   LibelleEtapeInfoStop : data.result.LibelleEtapeInfoStop,  IsStopAnalyse: data.result.IsStopAnalyse,    VolumeBassin: data.result.VolumeBassin, TemperatureEau : data.result.TemperatureEau, TypeFiltration : data.result.TypeFiltration, TypeFiltration_CONST: data.result.TypeFiltration_CONST, TypeDesinfection_CONST : data.result.TypeDesinfection_CONST, TypeDesinfection : data.result.TypeDesinfection, tempsFiltrationResult : data.result.tempsFiltrationResult , PH_Result : data.result.PH_Result, ChloreLibre_Result : data.result.ChloreLibre_Result  });
      }

    }).catch(function (error) {
      console.log("Error****:", error.message);
    });

  }



  downloadAnalyse(analyse){

    let url = `${this.state.baseURL}/analyse/${analyse}/printAnalyse`;
    window.open(url, '_blank');

  }


  async shareAnalyse(analyse) {

    let url = `${this.state.baseURL}/analyse/${analyse}/printAnalyse`;
    console.log(this.state.baseURL + url)

    let htmlEmail = `
      Cliquer sur le lien ci dessous pour visualiser l'analyse ${analyse}
      ${url}
    `
    window.open(`mailto:?subject=Pool Solutions - Partage analyse&body=${encodeURIComponent(htmlEmail)}`);
  }


  getGoutteByEtat(etat){

    switch (etat) {
      case 'BON':
        return goutte_verte;
        break;
      case 'MOYEN':
        return goutte_orange;
        break;
      case 'MAUVAIS':
        return goutte_rouge;
        break;
      default:
      return goutte_orange;
    }

  }


  handleChangeValue = (dataType, value) => {

    this.setState({[dataType]: value});
  }


  traitementAnalyse = () =>{

    window.location.href= '/analyseTraitement?analyse='+ this.state.GUID_Analyse;
  }


  traitementFormulaire = () =>{

    window.location.href= '/forms';
  }


  traitementFacultatif = () =>{

    //window.location.href= '/forms';
    this.setState({IsStopFacultatif : false})
  }


  click_IsTempsFiltrationClicked = () => {

    this.setState({IsTempsFiltrationClicked : true});
  }


  click_Stabilisant = () => {

    this.setState({IsStabilisantClicked : true});
  }


  click_EauClairTransparent = () => {

    this.setState({IsEauClairTransparentClicked : true});
  }


  showModal = () => {
    //  setIsModalOpen(true);
    };

  handleOk = () => {
    //  setIsModalOpen(false);
    };

  handleCancel = () => {
    //  setIsModalOpen(false);
    };


  getTypeFiltration_CONST(const_desinfection){

    /*
    CASE WHEN  Analyse.IsFiltreASable = 1 THEN 'FILTRE_A_SABLE'
  		    WHEN  Analyse.IsFiltreACartouche = 1 THEN 'FILTRE_A_CARTOUCHE'
  		    WHEN  Analyse.IsFiltreADiatomee = 1 THEN 'FILTRE_DIATOME'
  		    WHEN  Analyse.IsPocheFiltration = 1 THEN 'POCHE_FILTRATION'
    */

     if(this.state.language == 'fr'){

      if(const_desinfection == 'FILTRE_A_SABLE'){
        return "Filtre à sable"
      }

      if(const_desinfection == 'FILTRE_A_CARTOUCHE'){
        return "Filtre à cartouche"
      }

       if(const_desinfection == 'FILTRE_DIATOME'){
        return "Filtre à diatomée"
      }
        if(const_desinfection == 'POCHE_FILTRATION'){
        return "Poche filtration"
      }

    }

    if(this.state.language == 'en'){

      if(const_desinfection == 'FILTRE_A_SABLE'){
        return "Sand filter"
      }

      if(const_desinfection == 'FILTRE_A_CARTOUCHE'){
        return "Cartridge filter"
      }

       if(const_desinfection == 'FILTRE_DIATOME'){
        return "Diatomaceous earth filter"
      }
        if(const_desinfection == 'POCHE_FILTRATION'){
        return "Filter bag"
      }

    }

    if(this.state.language == 'de'){

      if(const_desinfection == 'FILTRE_A_SABLE'){
        return "Sandfilter"
      }

      if(const_desinfection == 'FILTRE_A_CARTOUCHE'){
        return "Kartuschenfilter"
      }

       if(const_desinfection == 'FILTRE_DIATOME'){
        return "Kieselgurfilter"
      }
        if(const_desinfection == 'POCHE_FILTRATION'){
        return "Filterbeutel"
      }

    }

    if(this.state.language == 'es'){

      if(const_desinfection == 'FILTRE_A_SABLE'){
        return "Filtro de arena"
      }

      if(const_desinfection == 'FILTRE_A_CARTOUCHE'){
        return "Filtro de cartucho"
      }

       if(const_desinfection == 'FILTRE_DIATOME'){
        return "Filtro de diatomeas"
      }
        if(const_desinfection == 'POCHE_FILTRATION'){
        return "Bolsa de filtración"
      }

    }

     if(this.state.language == 'it'){

      if(const_desinfection == 'FILTRE_A_SABLE'){
        return "Filtro a sabbia"
      }

      if(const_desinfection == 'FILTRE_A_CARTOUCHE'){
        return "Filtro a cartuccia"
      }

       if(const_desinfection == 'FILTRE_DIATOME'){
        return "Filtro a diatomee"
      }
        if(const_desinfection == 'POCHE_FILTRATION'){
        return "Sacca filtrante"
      }

    }

      if(this.state.language == 'pt-PT'){

      if(const_desinfection == 'FILTRE_A_SABLE'){
        return "Filtro de areia"
      }

      if(const_desinfection == 'FILTRE_A_CARTOUCHE'){
        return "Filtro de cartucho"
      }

       if(const_desinfection == 'FILTRE_DIATOME'){
        return "Filtro de diatomáceas"
      }
        if(const_desinfection == 'POCHE_FILTRATION'){
        return "Saco de filtração"
      }

    }


  }

  getCONST_TypeDesinfection(const_desinfection){

    if(this.state.language == 'fr'){
      if(const_desinfection == 'DESINFECTION_CHLORE_GALET'){
        return "Désinfection chlore galet"
      }

      if(const_desinfection == 'DESINFECTION_BROME'){
        return "Désinfection brome"
      }

       if(const_desinfection == 'DESINFECTION_CHLORE_LIQUIDE'){
        return "Désinfection chlore liquide"
      }
        if(const_desinfection == 'DESINFECTION_ELECTROLYSEUR'){
        return "Désinfection élétrolyseur"
      }

    }

    if(this.state.language == 'en'){
      if(const_desinfection == 'DESINFECTION_CHLORE_GALET'){
        return "Chlorine disinfection with tablets"
      }

      if(const_desinfection == 'DESINFECTION_BROME'){
        return "Bromine disinfection"
      }

       if(const_desinfection == 'DESINFECTION_CHLORE_LIQUIDE'){
        return "Liquid chlorine disinfection"
      }
        if(const_desinfection == 'DESINFECTION_ELECTROLYSEUR'){
        return "Disinfection with electrolyser"
      }

    }

    if(this.state.language == 'de'){
      if(const_desinfection == 'DESINFECTION_CHLORE_GALET'){
        return "Desinfektion mit Chlortabletten"
      }

      if(const_desinfection == 'DESINFECTION_BROME'){
        return "Desinfektion mit Brom"
      }

       if(const_desinfection == 'DESINFECTION_CHLORE_LIQUIDE'){
        return "Desinfektion mit Flüssigchlor"
      }
        if(const_desinfection == 'DESINFECTION_ELECTROLYSEUR'){
        return "Desinfektion mit Elektrolysegerät"
      }

    }

    if(this.state.language == 'es'){
      if(const_desinfection == 'DESINFECTION_CHLORE_GALET'){
        return "Desinfección con pastillas de cloro"
      }

      if(const_desinfection == 'DESINFECTION_BROME'){
        return "Desinfección con bromo"
      }

       if(const_desinfection == 'DESINFECTION_CHLORE_LIQUIDE'){
        return "Desinfección con cloro líquido"
      }
        if(const_desinfection == 'DESINFECTION_ELECTROLYSEUR'){
        return "Desinfección con electrolizador"
      }

    }

    if(this.state.language == 'it'){
      if(const_desinfection == 'DESINFECTION_CHLORE_GALET'){
        return "Disinfezione con pastiglie di cloro"
      }

      if(const_desinfection == 'DESINFECTION_BROME'){
        return "Disinfezione con bromo"
      }

       if(const_desinfection == 'DESINFECTION_CHLORE_LIQUIDE'){
        return "Disinfezione con cloro liquido"
      }
        if(const_desinfection == 'DESINFECTION_ELECTROLYSEUR'){
        return "Disinfezione con elettrolizzatore"
      }

    }

    if(this.state.language == 'pt-PT'){
      if(const_desinfection == 'DESINFECTION_CHLORE_GALET'){
        return "Desinfeção com pastilhas de cloro"
      }

      if(const_desinfection == 'DESINFECTION_BROME'){
        return "Desinfeção com bromo"
      }

       if(const_desinfection == 'DESINFECTION_CHLORE_LIQUIDE'){
        return "Desinfeção com cloro líquido"
      }
        if(const_desinfection == 'DESINFECTION_ELECTROLYSEUR'){
        return "Desinfeção com eletrólise"
      }

    }

  }



  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      return (

        <div className = "wrapper_analyse">

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

          <nav>
                  <ul>
                      <li><a href = "/"><img loading="lazy" src={picto_home} width ="180px"/></a></li>
                      <li><a style = {{marginTop : 10}} href="/forms">{t('menu_analyse')}</a></li>
                      <li><a href="/simulateur">{t('menu_calcul_volume')}</a></li>
                      <li><a href="/historique">{t('menu_historique')}</a></li>
                      <li> <span onClick={setDisconnectMachineId}> <a href="#">{t('menu_login') } </a> </span>  </li>

                      <li> 
                        <select
                          id="language-select"
                          value={this.state.language}
                          disabled = {false}
                          onChange={this.handleChangeLanguage}
                          style={{ padding: '5px', fontSize: '16px', cursor: 'pointer' }}
                        >
                          {this.state.languages_LIST.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                              {lang.flag} {lang.label}
                            </option>
                          ))}
                        </select>  
                      </li>

                  </ul>
            </nav>


          <div className = "wrapper_analyse_header">

          { this.state.IsStopAnalyse == true &&
            <Modal
              title="Avertissement"
              open={this.state.IsStopAnalyse}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              closable={false}
              footer={[

              ]}
              >
              <p>{this.state.LibelleEtapeInfoStop}</p>
              <div style = {{textAlign : 'center'} }>
                  <Button className = 'buttonFormStyle' onClick = {this.traitementFormulaire}  size={"large"} style={{fontWeight:600, paddingLeft:40, paddingRight:40, backgroundColor: '#0093CF', color:'white'}}>Nouvelle analyse</Button>
              </div>
            </Modal>
          }

          { this.state.IsStopFacultatif == true &&
            <Modal
              title="Avertissement"
              open={this.state.IsStopFacultatif}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              footer={[

              ]}
              >
              <p>{this.state.LibelleEtapeInfoFacult}</p>
              <div style = {{textAlign : 'center'} }>
                  <Button className = 'buttonFormStyle' onClick = {this.traitementFacultatif}  size={"large"} style={{fontWeight:600, paddingLeft:40, paddingRight:40, backgroundColor: '#0093CF', color:'white'}}>Continuer</Button>
              </div>
            </Modal>
          }

          </div>

          <div className= "bassin_wrapper">

          <p className = "analyse_Titre"></p>

          <div className = "analyse_text_containeur_bassin">
            <p>{t('analyse_title1')}</p>
          </div>
         

          <div className = "analyse_text_containeur">

          

          <Row>
            <Col span = {20}>
              <p><span>{t('analyse_info_volume')}</span> {this.state.VolumeBassin + " m³"}</p>
              <p><span>{t('analyse_info_type_filtration')} </span> {this.getTypeFiltration_CONST(this.state.TypeFiltration_CONST)}</p>
              <p><span>{t('analyse_info_type_desinfection')}</span> {this.getCONST_TypeDesinfection(this.state.TypeDesinfection_CONST)}</p>
              <p><span>{t('analyse_info_temperature_eau')}</span> {this.state.TemperatureEau + "°C"}</p>
            </Col>
            <Col span = {4} >
              <div>
                <img loading="lazy" style = {{marginTop:25}} src={picto_analyse_bleu} />
              </div>
            </Col>
          </Row>

          </div>

          <p className = "analyse_Titre_title"> {t('analyse_titleResultat')}</p>

          <Row align = "middle">

          {
            this.state.typeAnalyse_LIST.map((item) => (

              item.IsHideResultat == 0 ?
              <Col xl={4} lg={4} md={12} sm={12} xs={12} className = "equilibre_cell" >
                <div className = "equilibre_cell_imageTitre1">{this.getTempsFiltrationTypeLanguage(item)}</div>
                <div className = "equilibre_cell_imageTitre2">{item.Valeur + ' ' + item.Unite }</div>
                <img loading="lazy" width="120px" height="120px" src={this.getGoutteByEtat(item.CONST_ETAT)} />
                <div className = "equilibre_cell_text"><span> {t('analyse_resulat_ideal')} </span>{item.ValMini + ' - ' + item.ValMaxi + ' ' + item.Unite } </div>
              </Col>
              : null
          ))
          }

          </Row>

            <div style={{cursor: 'pointer'}} onClick = {this.handleChangeValue.bind(this, 'ShowTempsFiltration')}>
              <p className = "analyse_Titre"> {t('analyse_TempsFiltration')} <CaretUpOutlined style={{color: getColorWithState(this.state.tempsFiltrationResult ? this.state.tempsFiltrationResult.tempsFiltrationEtat : '') , fontSize: '20px', cursor: 'pointer'}} type="edit"/></p>
                <div className = "analyse_text_containeur">
                  <p className = "resumeTitre">{this.state.tempsFiltrationResult ? this.getTempsFiltrationTitreLanguage(this.state.tempsFiltrationResult) : '' }</p>
                  <p>{this.state.tempsFiltrationResult ? this.getTempsFiltrationDescriptionLanguage(this.state.tempsFiltrationResult) : ''}</p>
                </div>
            </div>

            {
              this.state.typeAnalyse_LIST.map((item) => (


                <div style={{cursor: 'pointer'}} onClick = {this.handleChangeValue.bind(this, 'ShowTempsFiltration')}>
                  {
                    item.ListEtapeAnalyse.length > 0 &&
                      <p className = "analyse_Titre">{this.getTempsFiltrationTypeLanguage(item)} <CaretUpOutlined style={{color: getColorWithState(item.CONST_ETAT) , fontSize: '20px', cursor: 'pointer'}} type="edit"/></p>
                  }

                  {
                    item.ListEtapeAnalyse.map((itemEtape) => (
                      <div className = "analyse_text_containeur">
                        <p className = "resumeTitre">{}</p>
                        <p>{this.getTempsFiltrationEtapeInfo(itemEtape)}</p>
                      </div>
                    ))
                  }
                </div>

            )
          )
            }

            <div className = "analyseResume_border">
            </div>
            {



              <Row>


                <Col span = {12} style= {{cursor: 'pointer', textAlign:'center', color : '#0093CF', fontSize : 35}}>

                <a style={{textDecoration: 'none', color : '#005397'}} target="_blank" href={`${this.state.baseURL}/analyse/${this.state.GUID_Analyse}/${this.state.language}/printAnalyseLanguage`}>
                  <span syle = {{color : '#0093CF'}}>{ this.state.loadingDownload == false ? <DownloadOutlined /> : <LoadingOutlined />}  </span>
                  <p className = "analyseResume_border_text">{t('analyse_resulat_download')}</p>
                </a>
                </Col>

                <Col span = {12} style= {{cursor: 'pointer', textAlign:'center', color : '#005397', fontSize : 35}}>
                  <span onClick={() => this.shareAnalyse(this.state.GUID_Analyse)} > { this.state.loadingShare == false ? <ShareAltOutlined /> : <LoadingOutlined />}  </span>
                  <p className = "analyseResume_border_text">{t('analyse_resulat_share')}</p>
                  
               
                </Col>
              </Row>
            }


         

          <div style = {{marginTop:10, marginBottom:20, textAlign : 'center'} }>
              <Button className = 'buttonFormStyle' onClick = {this.traitementFormulaire}  size={"large"} style={{width: "250px", borderRadius : 20, fontWeight:600, marginBottom: 100, borderColor: '#2B4570', backgroundColor: '#2B4570', color:'#FFFFFF'}}>{t('analyse_resulat_new')}</Button>
          </div>

          </div>

      

        </div>


      )

    };
}


/*
 <div style = {{marginTop:30, marginBottom:10, textAlign : 'center'} }>
              <Button className = 'buttonFormStyle' onClick = {this.traitementAnalyse}  size={"large"} style={{width: "250px",fontWeight:600,    backgroundColor: '#FFDD00', color:'#2B4570'}}>Traiter votre bassin</Button>
          </div>
*/
/*

<Row>
  <Col span = {12} style= {{cursor: 'pointer', textAlign:'center', color : '#0093CF', fontSize : 35}}>
    <span onClick={() => this.downloadAnalyse(this.state.GUID_Analyse)} > { this.state.loadingDownload == false ? <DownloadOutlined /> : <LoadingOutlined />}  </span>
    <p className = "analyseResume_border_text">Télécharger analyse</p>
  </Col>
*/


export default withTranslation() (AnalyseResume);
